/* ============================================================
   CREATORS.JS — Page-specific scripts for creators.html
   ============================================================ */

// ===== GSAP INIT =====

if(!motionReduced){

  // === Hero Section — Entry Animation ===
  const heroTl = gsap.timeline({ delay: 0.2 });
  heroTl
    .from('.creators-hero__headline', {
      y: 30, opacity: 0, duration: 0.6, ease: 'expo.out'
    })
    .from('.creators-hero__sub', {
      y: 20, opacity: 0, duration: 0.5, ease: 'expo.out'
    }, '-=0.3')
    .from('.creators-hero__rule', {
      scaleX: 0, opacity: 0, duration: 0.4, ease: 'power2.out'
    }, '-=0.2');

  // === Founder Section — Scroll Reveal ===
  // Photo slides in from left
  gsap.from('.founder__photo', {
    x: -40, opacity: 0, duration: 0.7, ease: 'expo.out',
    scrollTrigger: { trigger: '.founder', start: 'top 75%' }
  });

  // Content elements stagger in
  gsap.from('.founder__label, .founder__name, .founder__title, .founder__bio p', {
    y: 20, opacity: 0, stagger: 0.08, duration: 0.5, ease: 'power2.out',
    scrollTrigger: { trigger: '.founder__content', start: 'top 80%' }
  });

  // Credibility numbers count up
  document.querySelectorAll('.founder__cred-num').forEach(el => {
    const target = parseFloat(el.dataset.target);
    const prefix = el.dataset.prefix || '';
    const suffix = el.dataset.suffix || '';
    ScrollTrigger.create({
      trigger: '.founder__creds',
      start: 'top 85%',
      once: true,
      onEnter: () => {
        gsap.to({ v: 0 }, {
          v: target,
          duration: 1.0,
          ease: 'power2.out',
          onUpdate: function() {
            el.textContent = prefix + Math.round(this.targets()[0].v).toLocaleString() + suffix;
          }
        });
      }
    });
  });

  // Social links fade in
  gsap.from('.founder__social', {
    y: 10, opacity: 0, duration: 0.4, ease: 'power2.out',
    scrollTrigger: { trigger: '.founder__socials', start: 'top 90%' }
  });

  // === Collaborators Grid — Scroll Reveal ===
  gsap.from('.collabs__label, .collabs__title, .collabs__sub', {
    y: 20, opacity: 0, stagger: 0.08, duration: 0.5, ease: 'power2.out',
    scrollTrigger: { trigger: '.collabs__header', start: 'top 80%' }
  });

  gsap.from('.collab-card', {
    y: 30, opacity: 0, stagger: 0.06, duration: 0.5, ease: 'expo.out',
    scrollTrigger: { trigger: '.collabs__grid', start: 'top 80%' }
  });

  gsap.from('.collabs__teaser', {
    y: 15, opacity: 0, duration: 0.4, ease: 'power2.out',
    scrollTrigger: { trigger: '.collabs__teaser', start: 'top 90%' }
  });

  // === Bottom CTA — Scroll Reveal ===
  gsap.from('.creators-cta__heading, .creators-cta__sub, .creators-cta__primary', {
    y: 20, opacity: 0, stagger: 0.08, duration: 0.5, ease: 'power2.out',
    scrollTrigger: { trigger: '.creators-cta', start: 'top 80%' }
  });

  gsap.from('.creators-cta__signup-heading, .creators-cta__form', {
    y: 15, opacity: 0, duration: 0.4, ease: 'power2.out',
    scrollTrigger: { trigger: '.creators-cta__divider', start: 'top 85%' }
  });

} else {
  // Reduce motion: set everything to final state
  gsap.set([
    '.creators-hero__headline',
    '.creators-hero__sub',
    '.creators-hero__rule',
    '.founder__photo',
    '.founder__label',
    '.founder__name',
    '.founder__title',
    '.founder__bio p',
    '.founder__social',
    '.collab-card',
    '.collabs__label',
    '.collabs__title',
    '.collabs__sub',
    '.collabs__teaser',
    '.creators-cta__heading',
    '.creators-cta__sub',
    '.creators-cta__primary',
    '.creators-cta__signup-heading',
    '.creators-cta__form'
  ].join(', '), { opacity: 1, y: 0, x: 0, scaleX: 1 });

  // Set stats to final values
  document.querySelectorAll('.founder__cred-num').forEach(el => {
    const target = parseFloat(el.dataset.target);
    const prefix = el.dataset.prefix || '';
    const suffix = el.dataset.suffix || '';
    el.textContent = prefix + Math.round(target).toLocaleString() + suffix;
  });
}
